<template>
  <v-toolbar fixed flat id="titleBar" :height=40 style="top:60px;">
    <div v-show="showBreadCrumb" v-for="(item,index) in breadCrumbList" v-bind:key="item">
      <div class="titleBtn" v-if="index>0">></div>
      <v-btn flat class="titleBtn" v-show="userLogged" v-if="item=='Vessel View'" v-on:click="navTo(item)">{{ selVessel }}</v-btn>
      <v-btn flat class="titleBtn" v-show="userLogged" v-else-if="twin&&(skip_engine_steps.indexOf(item) < 0 && breadCrumbList.indexOf('Maintenance Tasks') < -1)" v-on:click="navTo(item)">{{ selEngine }} {{ item }}</v-btn>
      <v-btn flat class="titleBtn" v-show="userLogged" v-else v-on:click="navTo(item)"> {{ item }}</v-btn>
    </div>
    <div v-show="!showBreadCrumb">
      <v-btn flat class="titleBtn" v-on:click="goBack()">
        <v-icon dark left>arrow_back</v-icon>
        Back
      </v-btn>
      <v-btn flat class="titleBtn" v-show="userLogged" v-if="twin&&breadCrumbList[breadCrumbList.length-1]=='Report'" v-on:click="navTo(breadCrumbList[breadCrumbList.length-1])">{{ selEngine }} {{ breadCrumbList[breadCrumbList.length - 1] }}</v-btn>
      <v-btn flat class="titleBtn" v-show="userLogged" v-else v-on:click="navTo(breadCrumbList[breadCrumbList.length-1])"> {{ breadCrumbList[breadCrumbList.length - 1] }}</v-btn>
    </div>
    <v-spacer/>
    <v-btn flat v-show="userLogged" v-if="this.$route.name == 'Engine Faults'" v-on:click="navTo('Faults History')">Faults History</v-btn>
    <v-select
        v-show="userLogged"
        dark flat solo primary
        :class="'dateSelect'"
        v-model="select"
        :items="dropDownList"
        :label="label"
        background-color='rgb(51,82,128)'
        :style="'height:100%; max-width:200px; margin-top:15px; margin-bottom:5px; font-size:18px; margin-right: ' + ((timeStamp) ? 0 : 10) + 'px'"
    />
    <div v-show="timeStamp" class="timeStamp">{{ timeStamp }}</div>
    <v-dialog v-if="!openSecondary" v-model="dialog" max-width="300px" :style="'overflow: hidden;'">
      <div style="display:flex;justify-content:center;align-items:center;height: 370px; overflow: hidden">
        <v-date-picker
            id="startDatePicker"
            v-model="datePicked"
            :min="primaryDateMin"
            :max="primaryDateMax"
            color='rgb(51,82,128)'
            full-width
        />
      </div>
    </v-dialog>
    <v-dialog v-if="openSecondary" v-model="dialog" max-width="600px">
      <div style="position: relative; height: 415px;">
        <div style="display: inline-flex">
          <v-date-picker
              id="startDatePicker"
              v-model="datePicked"
              :min="primaryDateMin"
              :max="primaryDateMax"
              color='rgb(51,82,128)'
              full-width
          />
          <v-date-picker
              id="endDatePicker"
              ref="secondaryDatePicker"
              v-if="openSecondary"
              v-model="secondaryDate"
              :min="secondaryDateMin"
              :max="secondaryDateMax"
              color='rgb(51,82,128)'
              full-width
          />
        </div>
        <div style="width: 100%; background-color: white; position: absolute; bottom: 0; text-align: right;">
          <v-btn style="color:white; background-color: rgb(51,82,128);height:30px;" flat @click="submitPeriod">Submit</v-btn>
          <v-btn style="color:white; background-color: rgb(51,82,128);height:30px;" flat @click="clearPeriod">Clear</v-btn>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="alert" max-width="300px">
      <v-alert class='alert' :value="alert" type="info" transition="scale-transition" color='rgb(51,82,128)' outline>
        There is no available data for this date.
      </v-alert>
    </v-dialog>
    <v-dialog v-model="loading" max-width="200px">
      <div style="background-color:white;display:flex;justify-content:center;align-items:center;height:100px;">
        <v-progress-circular indeterminate :size="70" :width="7" color='rgb(51,82,128)' style="background-color:white;"></v-progress-circular>
      </div>
    </v-dialog>
  </v-toolbar>
</template>

<script>
/* eslint-disable no-console */
import {globalStore} from "../main.js"
import {getData} from "../getData.js";

var apiService;

export default {
  name: 'Titlebar',
  components: {},
  props: {},
  data() {
    return {
      breadCrumbList: ['Dashboard'],
      screenParams: {
        'Vessel View': ['vessel'],
        'Engine Performance': ['vessel', 'eng'],
        'Report': ['vessel', 'eng'],
        'Engine Faults': ['vessel', 'eng'],
        'Faults History': ['vessel', 'eng'],
        'Maintenance Tasks': ['vessel'],
        'Maintenance Tasks Filtered': ['vessel']
      },
      skip_engine_steps: [
        'Dashboard',
        'Maintenance Tasks',
        'Maintenance Tasks Filtered'
      ],
      dropDownList: ['Last Update', 'Today', 'Select Date', 'Select Period'],
      screensForBack: ['Settings', 'Alerts', /*'Faults History',*/ 'Report'],
      select: '',
      // selected: 'Last Update',
      label: 'Last Update',
      dialog: false,
      openSecondary: false,
      datePicked: '',
      secondaryDate: '',
      timeStamp: '',
      placeholder: '',
      alert: false,
      check: undefined,
      showBreadCrumb: true,
      dialogWidth: 600,
      primaryDateMin: '',
      primaryDateMax: '',
      secondaryDateMin: '',
      secondaryDateMax: '',
      maxDate: new Date(),
      maxDateString: new Date().toISOString(),
      mapAB: false,
      datePeriodLength: 90,
      pickerDate: null,
      secondaryPickerDate: null,
      alertTimer: null,
      created: false
    }
  },
  created() {
    apiService = new getData(globalStore.userProfile);

    let name = this.$route.name;

    if (this.screensForBack.includes(name))
      this.showBreadCrumb = false;
    else
      this.showBreadCrumb = true;

    if (globalStore.selectedVessel) {
      this.breadCrumbList.push('Vessel View');
    }

    if (typeof name != 'undefined') {
      let new_display = name;

      if (new_display == 'Maintenance Tasks Filtered') {
        new_display = 'Maintenance Tasks';
      }

      if (this.breadCrumbList.includes(new_display)) {
        let index = this.breadCrumbList.indexOf(new_display);

        this.breadCrumbList = this.breadCrumbList.slice(0, index + 1);
      } else {
        this.breadCrumbList.push(new_display);
      }

      if (name == 'Maintenance Tasks Filtered') {
        this.breadCrumbList.push(`Task - ${this.$route.params['id']}`);
      }
    }

    if (
        Object.keys(this.$route.params).indexOf('date') > -1    // Check if parameter exists
        && !!this.$route.params['date']                         // Check if parameter is set
        && !isNaN(Date.parse(this.$route.params['date']))       // Check if parameter is date
    ) {
      if (
          Object.keys(this.$route.params).indexOf('end') > -1   // Check if parameter exists
          && !!this.$route.params['end']                        // Check if parameter is set
          && !isNaN(Date.parse(this.$route.params['end']))      // Check if parameter is date
      ) {
        this.secondaryDate = this.$route.params['end'];
        this.label = 'Select Period';
      } else {
        this.label = 'Select Date';
      }
      this.datePicked = this.$route.params['date'];

      this.select = this.label;
    } else {
      this.select = 'Last Update';
      this.created = true
    }
  },
  methods: {
    navTo(screen) {

      if (screen in this.screenParams) {
        let paramItem = {};

        this.screenParams[screen].forEach(param => {
          if (param in this.$route.params) paramItem[param] = this.$route.params[param];
        })

        this.$router.push({name: screen, params: paramItem});
      } else this.$router.push({name: screen})
    },
    goBack() {
      this.$router.go(-1);
    },
    setBoundariesOnSecondaryDate() {

      var queryStartDate = new Date(this.datePicked),
          minDateTo = new Date(this.datePicked),
          maxDateTo = new Date(new Date(this.datePicked).setDate(queryStartDate.getDate() + this.datePeriodLength + 1));

      this.secondaryDateMin = minDateTo.toISOString();
      this.secondaryDateMax = ((maxDateTo < this.maxDate) ? maxDateTo.toISOString() : this.maxDateString);
    },
    setBoundariesOnPrimaryDate() {
      if (this.secondaryDate) {
        var queryStartDate = new Date(this.secondaryDate),
            minDateTo = new Date(new Date(this.secondaryDate).setDate(queryStartDate.getDate() - this.datePeriodLength - 1)),
            maxDateTo = new Date(new Date(this.secondaryDate).setDate(queryStartDate.getDate() - 1));


        this.primaryDateMin = minDateTo.toISOString();
        this.primaryDateMax = maxDateTo.toISOString();
      }
    },
    setTimestamp() {
      switch (this.placeholder) {
        case 'Select Date':
          this.timeStamp = this.datePicked;
          break;
        case 'Select Period':
          this.timeStamp = this.datePicked + ' - ' + this.secondaryDate;
          break;
        case 'Last Update':
        case 'Today':
          this.timeStamp = '';
          break;
      }
    },

    //Set the default upper limit of date pickers.
    //Any date over the max will result to error.
    setCurrentMaxDate() {
      var tmp = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T');

      this.maxDateString = tmp[0] + 'T' + tmp[1].replace(/\d/g, 0);

      this.secondaryDateMax = this.maxDateString;
      this.primaryDateMax = this.maxDateString;
    },

    submitPeriod() {
      if (this.datePicked.length && this.secondaryDate.length) {
        apiService.checkDate(this.datePicked, globalStore.selectedIMO, this.secondaryDate);
      }
    },
    clearPeriod() {
      this.datePicked = '';
      this.secondaryDate = '';
    },
    allowed_dates: (val) => {
      if (!globalStore.selectedIMO) {
        return Object.keys(globalStore.available_dates || {}).indexOf(val) >= 0
      } else {
        return Object.keys(globalStore.available_dates).filter((date) => {
          return globalStore.available_dates[date].indexOf(globalStore.selectedIMO) > -1
        }).indexOf(val) >= 0
      }
    },
    handlePickerDateUpdate: (newV, oldV) => {
      let available_dates = Object.keys(globalStore.available_dates);

      if (available_dates.length) {
        let target_year = newV.substring(0, 4),
            newDate = new Date(newV),
            oldDate = new Date(oldV);

        if (newDate.getFullYear() < oldDate.getFullYear() && newDate <= new Date()) {
          let year_not_found = Object.keys(globalStore.available_dates).map((date) => {
            return date.substring(0, 4);
          }).indexOf(target_year) < 0;

          if (year_not_found) {
            apiService.checkYearAvailability(target_year);
            globalStore.loading = true
          }
        }
      }
    }
  },
  computed: {
    loading: function () {
      if (globalStore.expectingVesselData && !globalStore.loading)
        globalStore.loading = true;

      return globalStore.loading;
    },
    currPath: function () {
      return this.$route.path;
    },
    selVessel: function () {
      return globalStore.selectedVessel;
    },
    userLogged: function () {
      return globalStore.userLogged;
    },
    dataLoaded: function () {
      return globalStore.type;
    },
    checkedDate: function () {
      return globalStore.checkedDate;
    },
    mapDate: function () {
      return globalStore.mapDate;
    },
    alertDate: function () {
      return globalStore.alertDate;
    },
    twin: function () {
      return globalStore.twinEngine;
    },
    currentRouteName: function () {
      return this.$route.name;
    },
    selEngine: {
      cache: false,
      get: function () {
        return globalStore.selectedEngine;
      }
    },
    dates_availability: function () {
      return globalStore.available_dates;
    },
  },
  watch: {
    currPath: function () {
      let name = this.$route.name;

      if (this.screensForBack.includes(name))
        this.showBreadCrumb = false;
      else
        this.showBreadCrumb = true;

      if (this.breadCrumbList.includes(name)) {
        let index = this.breadCrumbList.indexOf(name);

        this.breadCrumbList = this.breadCrumbList.slice(0, index + 1);
      } else if (name == 'Engine Faults') {
        this.breadCrumbList = ['Dashboard', 'Vessel View', 'Engine Faults'];
      } else {
        this.breadCrumbList.push(name);
      }
    },
    select: function () {
      if (this.select != '') {
        globalStore.loading = false;

        switch (this.select) {
          case 'Select Date':
            if (this.created) {
              this.dialog = true;
              this.openSecondary = false;
            } else {
              this.dialog = false;
              this.openSecondary = false;
            }
            break;
          case 'Select Period':
            if (this.created) {
              this.dialog = true;
              this.openSecondary = true;
            } else {
              this.dialog = false;
              this.openSecondary = false;
            }
            break;
          case 'Last Update':
          case 'Today':
            apiService.checkDate(((this.select == 'Last Update') ? 'last' : 'today'), globalStore.selectedIMO);
            break;
        }

        this.placeholder = this.select;
        this.label = this.select;
        this.select = '';
        this.created = true
      }
    },
    selVessel: async function () {
      globalStore.loading = true;

      if (this.breadCrumbList.indexOf('Vessel View') < 0) {
        if (this.breadCrumbList.length < 2) {
          this.breadCrumbList = [this.breadCrumbList[0], 'Vessel View']
        } else {
          this.breadCrumbList = [this.breadCrumbList[0], 'Vessel View', ...this.breadCrumbList.slice(1)]
        }
      }

      if (globalStore.checkedDate) {
        if (this.placeholder == 'Last Update' || this.currentRouteName.toLowerCase() == 'dashboard')
          apiService.getData('last', globalStore.selectedIMO);
        else if (this.placeholder == 'Today')
          apiService.getData('today', globalStore.selectedIMO);
        else {
          var isPeriod = this.placeholder == 'Select Period' && this.secondaryDate.length;
          if (!isPeriod)
            apiService.getData(this.datePicked, globalStore.selectedIMO);
          else
            apiService.getData(this.datePicked, globalStore.selectedIMO, this.secondaryDate);
        }
      }
    },
    mapDate: function () {
      if (globalStore.mapDate.length) {
        var date = globalStore.mapDate;

        if (date instanceof Array) {
          this.select = 'Select Period';
          this.placeholder = 'Select Period';

          this.secondaryDate = null;
          this.datePicked = null;

          this.openSecondary = true;

          setTimeout(() => {
            this.dialog = false;
            this.openSecondary = false;

            this.mapAB = true;

            this.secondaryDate = date[1];
            this.datePicked = date[0];
          }, 200);
        } else {
          this.select = 'Select Date';
          this.placeholder = 'Select Date';
          this.datePicked = null;

          setTimeout(() => {
            this.dialog = false;
            this.openSecondary = false;

            this.datePicked = date;
          }, 200);
        }

        globalStore.mapDate = '';
      }
    },
    alertDate: function () {
      if (this.alertDate != '') {

        globalStore.loading = true;

        let dayMS = 24 * 3600 * 1000;

        if ((new Date().getTime() - new Date(this.alertDate).getTime()) > dayMS) {
          this.select = 'Select Date';
          this.placeholder = 'Select Date';
          this.datePicked = this.alertDate;
        } else {
          this.select = 'Today';
          this.placeholder = 'Today';
        }

        setTimeout(() => {
          this.dialog = false;
          this.openSecondary = false;
          globalStore.alertDate = '';
        }, 200);

        // this.placeholder = 'Select Date';
        // this.datePicked = this.alertDate;
      }
    },
    datePicked: function () {
      if (this.mapAB) {
        apiService.checkDate(this.datePicked, globalStore.selectedIMO, this.secondaryDate);
      } else {
        if (!this.openSecondary && !this.secondaryDate && this.datePicked != null && this.datePicked.length) {
          this.secondaryDate = '';

          apiService.checkDate(this.datePicked, globalStore.selectedIMO);
        } else {
          if (typeof this.datePicked != 'undefined' && this.datePicked != null && this.datePicked.length) {
            this.setBoundariesOnSecondaryDate();
          } else {
            this.secondaryDateMin = '';
            this.secondaryDateMax = this.maxDateString;
          }

          if (this.secondaryDate) {
            apiService.checkDate(this.datePicked, globalStore.selectedIMO, this.secondaryDate);
          }
        }
      }
    },
    secondaryDate: function () {
      if (this.secondaryDate.length) {
        this.setBoundariesOnPrimaryDate();
      } else {
        this.primaryDateMin = '';
        this.primaryDateMax = this.maxDateString;
      }
    },
    dataLoaded: function () {

      //if (globalStore.type) {
      if (globalStore.validDate) {
        this.setTimestamp();
      }
    },
    checkedDate(check) {
      if (check) {
        if (globalStore.validDate) {
          switch (this.placeholder) {
            case 'Select Date':
              apiService.getData(this.datePicked, globalStore.selectedIMO);
              break;
            case 'Select Period':
              apiService.getData(this.datePicked, globalStore.selectedIMO, this.secondaryDate);
              break;
            case 'Last Update':
            case 'Today':
              apiService.getData(((this.placeholder == 'Last Update') ? 'last' : 'today'), globalStore.selectedIMO);
              break;
          }
        } else {
          this.alert = true;
        }
      }

      this.mapAB = false;
      this.dialog = false;
      this.openSecondary = false;
    },
    currentRouteName: function () {
      if (this.currentRouteName.toLowerCase() == 'dashboard') {
        this.select = 'Last Update';
        this.timeStamp = '';
      }
    },
    openSecondary: function () {
      if (!this.openSecondary) {
        this.primaryDateMin = '',
            this.primaryDateMax = this.maxDateString;
      } else {
        this.setBoundariesOnPrimaryDate();
      }
    },
    dates_availability: function () {
      let dialog_tmp = this.dialog;
      this.dialog = false;
      this.dialog = dialog_tmp;
      globalStore.loading = false;
    },
    pickerDate: function (newV, oldV) {
      this.handlePickerDateUpdate(newV, oldV);
    },
    secondaryPickerDate: function (newV, oldV) {
      this.handlePickerDateUpdate(newV, oldV);
    },
  },
  mounted() {
    this.setCurrentMaxDate();
  },
  updated() {
    try {
      clearTimeout(this.alertTimer);
    } catch (e) {
    }

    this.alertTimer = setTimeout(() => {
      if (globalStore.userLogged) {
        apiService.getUserNotifications();
      }
    }, 250)
  }
}
</script>

<style scoped>
#titleBar {
  background-color: rgb(244, 244, 244);
  padding: 0px;
  font-size: 24px;
  color: rgb(51, 82, 128);
}

.titleBtn {
  color: rgb(51, 82, 128);
  font-size: 20px;
  text-transform: none;
  display: inline-block;
  height: 100%;
}

.timeStamp {
  color: rgb(51, 82, 128);
  font-size: 16px;
  text-transform: none;
  display: flex;
  align-items: center;
  border-style: solid;
  border-color: rgb(51, 82, 128);
  border-width: 2px;
  padding-left: 10px;
  padding-right: 10px;
  height: 32px;
  margin-top: 15px;
  margin-bottom: 13px;
}
</style>

<style>
.v-input__slot {
  min-height: 0px;
}

.alert {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 250px;
  height: 100px;
  background-color: white;
}

#startDatePicker {
  min-width: 300px;
  max-width: 300px;
  min-height: 370px;
  max-height: 370px;
}

#endDatePicker {
  min-width: 300px;
  max-width: 300px;
  min-height: 370px;
  max-height: 370px;
}

#titleBar .v-toolbar__content {
  padding: 0 !important;
}

#titleBar .timeStamp {
  margin-right: 10px !important;
}

.dateSelect .v-select__selection.v-select__selection--comma {
  position: relative;
  left: 8px;
}

.dateSelect .v-select__selections input {
  display: none;
}

.dateSelect .v-select__slot {
  height: 32px;
}

.dateSelect .v-label {
  position: absolute !important;
  color: #fff !important;
  font-size: 18px !important;
  font-weight: 400 !important;
  /*line-height: 18px !important;*/
  left: 8px !important;
}

.dateSelect .v-label.v-label--active {
  display: none !important;
}
</style>